import React from "react";

const PensfordNotes = () => <div />;

export default PensfordNotes;
